import _implicitStylesheets from "./iconInteractive.css";
import _implicitScopedStylesheets from "./iconInteractive.scoped.css?scoped=true";
import _axIconInteractive from "ax/iconInteractive";
import _wdsAnalyticsInstrument from "wds/analyticsInstrument";
import {freezeTemplate, registerTemplate} from "lwc";
const stc0 = {
  "type": "button"
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {b: api_bind, c: api_custom_element} = $api;
  const {_m0, _m1} = $ctx;
  return [api_custom_element("wds-analytics-instrument", _wdsAnalyticsInstrument, {
    props: stc0,
    key: 0,
    on: {
      "analytics": _m0 || ($ctx._m0 = api_bind($cmp.handleAnalytics)),
      "click": _m1 || ($ctx._m1 = api_bind($cmp.handleClick))
    }
  }, [api_custom_element("ax-icon-interactive", _axIconInteractive, {
    attrs: {
      "data-id": $cmp.id
    },
    props: {
      "icon": $cmp.icon,
      "disabled": $cmp.disabled,
      "type": $cmp.type,
      "size": $cmp.size,
      "ariaLabel": $cmp.ariaLabel,
      "ariaLive": $cmp.ariaLive,
      "form": $cmp.form,
      "theme": $cmp.theme,
      "href": $cmp.href
    },
    key: 1
  })])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-790mho1l7qt";
tmpl.legacyStylesheetToken = "undefined-_iconInteractive";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
